//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    options: { type: Array, default () { return [] } },
    value: { type: Array, default () { return [] } },
    // 是否允许父节点被选中
    parentSelectable: { type: Boolean, default: false },
    iconpattern: String
  },
  computed: {
    currentValue: {
      set (val) {
        this.$emit('input', val)
      },
      get () {
        return JSON.parse(JSON.stringify(this.value))
      }
    }
  },
  methods: {
    handleClick (item) {
      this.$emit('item-click', item)
    }
  }
}



// WEBPACK FOOTER //
// ./packages/tree-selector/src/tree-checkbox-list.vue